<template>
  <div>
    <!-- 按钮 -->
    <el-button @click="add" type="primary" class="addApp">添加APP</el-button>
    <!-- 列表 -->
    <el-table v-loading="loading" element-loading-text="拼命加载中" stripe :data="tableData">
      <el-table-column label="APP 名称" prop="name">
      </el-table-column>
      <el-table-column label="notifyURL" prop="notifyURL">
      </el-table-column>
      <el-table-column label="备注" prop="remark">
      </el-table-column>
       <el-table-column label="创建时间" prop="createdAt">
      </el-table-column>
      <el-table-column label="操作">
        <template scope="scope">
          <el-button size="small" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Page :way="ways" @pageNum='pageNum' @pageOne='pageOne'></Page>  

    <!-- 弹框 编辑 -->
    <el-dialog title="APP操作" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="app名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="app地址" :label-width="formLabelWidth">
          <el-input v-model="form.notifyURL" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="form.remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editOpt" v-if="editLoad">编 辑</el-button>
        <el-button type="primary" @click="addOpt" v-if="addLoad">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import util from '../../util/util';
import Page from '../../components/Page.vue'

export default {
  components: {
    Page
  },
  data() {
    return {
      tableData: [],
      loading: true,
      form: {
        name: '',
        notifyURL: '',
        remark: ''
      },
      dialogFormVisible: false,
      editData: {},
      formLabelWidth: '100px',
      addLoad: false,
      editLoad: false,
      ways: '/apps',
      skip: util.skip,
      limit: util.limit
    }
  },
  methods: {
    pageNum(msg){
      this.limit = msg ;
      this.getData();
    },
    pageOne(msg){
      this.skip = msg -1 ;
      this.getData();
    },
    getData() {
      axios.get('/apps', {
        params: {
          limit: this.limit,
          skip: this.skip * this.limit,
          order: '-createdAt'
        }
      }).then((response) => {
        this.tableData = response.data ;
        this.tableData.filter(item=>{item.createdAt=util.dateForm(item.createdAt)})
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      })
    },
    add() {
      this.dialogFormVisible = true;
      this.addLoad = true;
      this.editLoad = false;
      this.form = {};
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.editData = row ;
      this.form.name = row.name;
      this.form.remark = row.remark;
      this.form.notifyURL = row.notifyURL;
      this.addLoad = false;
      this.editLoad = true;
    },
    addOpt() {
      this.dialogFormVisible = false;
      axios.post('/apps', this.form).then((response) => {
        this.getData();
      }).catch((error) => {
        this.getData();
      })
    },
    editOpt() {
      this.dialogFormVisible = false;
      axios.put('/apps/'+ this.editData.objectId, this.form).then((response) => {
        this.getData()
      }).catch((error) => {
        this.getData()
      })
    }
  }
}
</script>


<style lang="scss" scoped>
@import 'src/styles/mixin.scss';

.addApp {
  @include floatBtn;
  float: right;
  margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/app/App.vue?75b4da7a